var __jsx = React.createElement;
import React from 'react';
import styles from '../styles/lead/LoginPromo.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

var LoginPromo = function LoginPromo(props) {
  var goToLogin = props.goToLogin;
  return __jsx("div", {
    className: "".concat(styles.root)
  }, __jsx("p", {
    className: "mb-0 heading3 font-weight-bold"
  }, __jsx(FontAwesomeIcon, {
    icon: faUser,
    height: "16",
    width: "16",
    size: "1x",
    className: "green mr-2"
  }), "Ai deja cont?"), __jsx("p", {
    className: "mb-1"
  }, __jsx("span", {
    className: styles.link,
    onClick: goToLogin
  }, "Conecteaz\u0103-te"), " \u0219i formularul va fi precompletat cu datele din profil."));
};

export default LoginPromo;